// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__spTO3","signup":"Profile_signup__5sU-8"};